import Immutable from 'immutable';
import {
  FLAG_GETTING_GEOGRAPHIC_ZONES,
  GET_GEOGRAPHIC_ZONES,
  CLEAR_GEOGRAPHIC_ZONES,
  FLAG_GEOGRAPHIC_ZONE_ACTIVITY,
  CLEAR_GEOGRAPHIC_ZONE,
  GET_GEOGRAPHIC_ZONE,
} from '../../../actions/types/location';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_GEOGRAPHIC_ZONES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_GEOGRAPHIC_ZONES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_GEOGRAPHIC_ZONES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_GEOGRAPHIC_ZONE_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_GEOGRAPHIC_ZONE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_GEOGRAPHIC_ZONE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
